import BaseAPIClient from '~/clientUtils/baseApiClient';
import { SaveVoteResponse, VoteData } from '~/definitions/vote';

class VoteApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async saveVote(params: VoteData[]): Promise<SaveVoteResponse> {
        return this.request({
            method: 'POST',
            url: `/api/vote`,
            data: params,
        });
    }
}

const voteApi = new VoteApi();

export default voteApi;
